export const styles = {
	mainBox: {
		display: 'flex',
	},
	marginRightBox: {
		marginRight: '2rem',
	},
	paper: {
		padding: '2rem',
		backgroundColor: '#FEF1F3',
		height: '40.8rem',
		overflow: 'hidden',
		overflowY: 'scroll',
		color: 'black',
	},
	refreshButtonBox: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'end',
		alignItems: 'center',
		gap: '1rem',
	},
	sideBar: {
		display: { xs: 'none', sm: 'block' },
		minWidth: '4px',
		background: 'linear-gradient(0deg, #ff8a9f 60%, #f3123f 90%)',
		marginRight: '2rem',
	},
	techniqueBox: {
		'white-space': 'pre-line',
	},
	typography: {
		opacity: 0.87,
		color: 'black',
	},
	typographyBox: {
		display: 'flex',
		flexDirection: 'column',
		gap: '2rem',
		flexGrow: '1',
	},
}
